/**
 * row 每行展示几个 默认是4个
 * isAside 列表width占满一页时候不用传或者false 其他情况传true
 */
import { DatePicker, Form, Input, Select, TreeSelect, Tooltip, Typography } from 'antd'
import React, { useEffect, useMemo, useState, useRef, useImperativeHandle, forwardRef } from 'react'
import styled from 'styled-components'
import { IconFont } from '../iconfont'
import { useDebounceFn, useDebounce } from 'ahooks'
import dayjs from '@/utils/dayjs'
import { Params } from '../list-page'
import { t } from '@/i18n'

const { TreeNode } = TreeSelect
interface Data {
  id: string | number | null
  name: string | null
  count?: number | null
  children?: Data[] //treeSelect
}
export type OptionType = {
  [key: string]: {
    label: string
    type:
      | 'input'
      | 'radio'
      | 'multiple'
      | 'time'
      | 'date'
      | 'dateCurrentTime'
      | 'dateNoTime'
      | 'treeSelect'
    data?: Data[] | Array<{ value; title; children; disabled }> | Array<{ value; title }>
    allowClear?: boolean
    placeholder?: string | string[]
    maxLength?: number
    /**接口参数 例如时间选择器 ['start_time','end_time'] */
    apiParams?: string[]
    typeof?: 'string' | 'array'
    isScript?: boolean
    props?: any
    searchLimit?: number
    ranges?: {}
    rules?: any[]
  }
}
interface FilterFormProps {
  option: OptionType
  row?: number
  onReset: (d?: any) => void
  setFilterHeight?: React.Dispatch<React.SetStateAction<number>>
  isAside?: boolean
  setSearchParams: React.Dispatch<React.SetStateAction<Params | any>>
  /**列表和搜索同步搜索参数 仅限在list-page使用 */
  setFilterParams?: React.Dispatch<
    React.SetStateAction<
      | {
          [k: string]: string | number | undefined
        }
      | undefined
    >
  >

  filterParams?:
    | {
        [k: string]: string | number | undefined
      }
    | undefined
  clearParams?: string[]
  isScript?: boolean
}
export const FilterForm: React.FC<FilterFormProps> = forwardRef(
  (
    {
      option,
      row = 4,
      onReset,
      setFilterHeight,
      setSearchParams,
      isAside = false,
      setFilterParams,
      filterParams,
      clearParams,
      isScript,
    },
    ref,
  ) => {
    const [form] = Form.useForm()
    const [visible, setVisible] = useState(false)
    const [params, setParams] = useState<object>()
    const [isFocus, setIsFocus] = useState({ focusType: '', blurType: '' })
    const SearchData = useMemo(() => {
      let arr: any = []
      if (option) {
        arr = Object.keys(option)
        if (arr.length > row) {
          arr.push('重置')
        }
      }
      let index = 0
      let newArray = [] as Array<Array<string>>
      while (index < arr.length) {
        newArray.push(arr.slice(index, (index += row)))
        let num = 0
        if (isAside) {
          newArray[newArray?.length - 1]?.map((item, i) => {
            if (
              option?.[item]?.type === 'time' &&
              i !== newArray[newArray?.length - 1].length - 1
            ) {
              num += 1
              newArray[newArray?.length - 1].pop()
            }
          })
        }
        index -= num
      }
      let arrLength = newArray?.length - 1
      let arrEnd = newArray[arrLength] as string[]
      if (arrLength > 0 && arrEnd && arrEnd[arrEnd.length - 1] !== '重置') {
        let a = 0
        if (isAside) {
          arrEnd?.map(item => {
            if (option?.[item]?.type === 'time') {
              a += 1
            }
          })
        }
        if (arrEnd.length < ((row / a) | 0)) {
          arrEnd.push('重置')
        } else {
          newArray.push(['重置'])
        }
      }
      return newArray
    }, [option])
    useEffect(() => {
      if (filterParams) {
        if (Object.keys(filterParams)?.length > 0) {
          form.setFieldsValue(filterParams)
          setParams(origin => ({ ...origin, ...filterParams }))
        } else {
          form.resetFields()
          setParams({})
        }
      }
    }, [filterParams])
    const { run } = useDebounceFn(
      d => {
        let obj = JSON.parse(JSON.stringify(d))
        let obj2 = {}
        let obj3 = {}
        for (const key in option) {
          if (option[key]?.type === 'time') {
            if ((option[key]?.apiParams || [])?.length > 0) {
              obj2[(option[key]?.apiParams || [])?.[0]] =
                obj[key]?.length > 0 ? dayjs(obj[key]?.[0]).format('YYYY-MM-DD HH:mm:ss') : ''
              obj2[(option[key]?.apiParams || [])?.[1]] =
                obj[key]?.length > 0 ? dayjs(obj[key]?.[1]).format('YYYY-MM-DD HH:mm:ss') : ''
            }
            obj[key] = undefined
          }
          if (option[key]?.type === 'date') {
            if ((option[key]?.apiParams || [])?.length > 0) {
              obj2[(option[key]?.apiParams || [])?.[0]] =
                obj[key]?.length > 0 ? `${dayjs(obj[key]?.[0]).format('YYYY-MM-DD')} 00:00:00` : ''
              obj2[(option[key]?.apiParams || [])?.[1]] =
                obj[key]?.length > 0 ? `${dayjs(obj[key]?.[1]).format('YYYY-MM-DD')} 23:59:59` : ''
            }
            obj[key] = undefined
          }
          if (option[key]?.type === 'dateCurrentTime') {
            if ((option[key]?.apiParams || [])?.length > 0) {
              obj2[(option[key]?.apiParams || [])?.[0]] =
                obj[key]?.length > 0 ? `${dayjs(obj[key]?.[0]).format('YYYY-MM-DD HH:mm:ss')}` : ''
              obj2[(option[key]?.apiParams || [])?.[1]] =
                obj[key]?.length > 0 ? `${dayjs(obj[key]?.[1]).format('YYYY-MM-DD HH:mm:ss')} ` : ''
            }
            obj[key] = undefined
          }
          if (option[key]?.type === 'dateNoTime') {
            if ((option[key]?.apiParams || [])?.length > 0) {
              obj2[(option[key]?.apiParams || [])?.[0]] =
                obj[key]?.length > 0 ? `${dayjs(obj[key]?.[0]).format('YYYY-MM-DD')}` : ''
              obj2[(option[key]?.apiParams || [])?.[1]] =
                obj[key]?.length > 0 ? `${dayjs(obj[key]?.[1]).format('YYYY-MM-DD')}` : ''
            }
            obj[key] = undefined
          }
          if (option[key]?.type === 'multiple' || option[key]?.type === 'treeSelect') {
            if (option[key]?.typeof && option[key]?.typeof === 'array') {
              obj[key] = obj[key] || undefined
            } else obj[key] = obj[key]?.join(',') || undefined
          }
          if (option[key]?.type === 'radio') {
            obj[key] = obj[key] || undefined
          }
        }
        if (clearParams) {
          clearParams?.map(item => {
            obj3[item] = undefined
          })
        }
        if (setFilterParams) setFilterParams(d)
        setSearchParams((origin: any) => ({
          ...origin,
          ...obj,
          ...obj2,
          ...obj3,
          page: origin?.page ? 1 : undefined,
        }))
      },
      {
        wait: 500,
      },
    )
    const { run: r } = useDebounceFn(
      d => {
        if (setFilterHeight) setFilterHeight(d)
      },
      {
        wait: 200,
      },
    )
    const reset = () => {
      form.resetFields()
      setParams({})
      if (setFilterParams) setFilterParams({})
      onReset()
    }

    useImperativeHandle(ref, () => ({
      onResetForm() {
        // logic to reset the form
        reset()
      },
    }))

    return (
      <FilterContent
        isScript={isScript}
        visible={visible}
        isShow={SearchData?.length > 1}
        length={SearchData?.length}
        formLength={option && Object.keys(option)?.length}
        row={row}
        isTime={
          option &&
          Object.keys(option)?.length - 1 < row &&
          option[Object.keys(option)[Object.keys(option)?.length - 1]]?.type === 'time'
        }
      >
        {option && (
          <div className="filter-search">
            <Form
              className="filter-form"
              layout="vertical"
              form={form}
              onValuesChange={async (e, d) => {
                try {
                  const values = await form.validateFields()
                  console.log(values)
                } catch (error) {
                  if (error?.errorFields?.length > 0) {
                    return
                  }
                }
                run(d)
                setParams(d)
              }}
            >
              {SearchData?.map((item: any, index) => {
                let n = 0
                return (
                  <div className="filter-flex" key={index}>
                    {item?.map((i, index2) => {
                      if (i === '重置') {
                        return (
                          <div
                            onClick={reset}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              height: 32,
                              marginTop: 6,
                              cursor: 'pointer',
                              color: '#4238C9',
                            }}
                            key={index2}
                          >
                            {t('重置')}
                          </div>
                        )
                      } else {
                        if (option?.[i]?.type === 'time') {
                          n += 1
                        }
                        return (
                          <div
                            className={`form-item ${
                              option?.[i]?.type !== 'time' &&
                              option?.[i]?.type !== 'date' &&
                              option?.[i]?.type !== 'dateCurrentTime' &&
                              option?.[i]?.type !== 'dateNoTime' &&
                              option?.[i]?.type !== 'input' &&
                              `${option?.[i]?.type}-item`
                            } ${params?.[i]?.toString()?.length > 0 && 'focus-item'}`}
                            data-placeholder={!option?.[i]?.placeholder ? option?.[i]?.label : ''}
                            key={index2}
                            style={{
                              width:
                                option?.[i]?.type === 'time' &&
                                !isAside &&
                                item.length <= ((row / n) | 0) &&
                                item.length !== row
                                  ? `calc(100% / ${row} * 2 - 12px)`
                                  : '',
                            }}
                            onClick={() => {
                              if (isFocus.blurType === i) {
                                setIsFocus({ focusType: i, blurType: '' })
                              } else setIsFocus(origin => ({ ...origin, focusType: i }))
                            }}
                          >
                            {option?.[i]?.type === 'input' && (
                              <Form.Item name={i} rules={option?.[i]?.rules}>
                                <Input
                                  prefix={
                                    <IconFont
                                      type="icon-sousuo1"
                                      style={{ color: '#666', fontSize: 16 }}
                                    />
                                  }
                                  placeholder={
                                    (option?.[i]?.placeholder || option?.[i]?.label) as string
                                  }
                                  allowClear
                                  maxLength={
                                    option?.[i]?.maxLength ? option?.[i]?.maxLength : 999999
                                  }
                                />
                              </Form.Item>
                            )}
                            {(option?.[i]?.type === 'time' ||
                              option?.[i]?.type === 'dateCurrentTime') && (
                              <Form.Item name={i}>
                                <DatePicker.RangePicker
                                  style={{ width: '100%' }}
                                  showTime
                                  ranges={option?.[i]?.ranges}
                                  format={'YYYY-MM-DD HH:mm:ss'}
                                  getPopupContainer={(node: any) =>
                                    node.parentNode?.parentNode?.parentNode?.parentNode?.parentNode
                                      ?.parentNode?.parentNode?.parentNode || document.body
                                  }
                                  placeholder={
                                    (option?.[i]?.placeholder as [string, string]) || [
                                      option?.[i]?.label,
                                      option?.[i]?.label,
                                    ]
                                  }
                                />
                              </Form.Item>
                            )}
                            {option?.[i]?.type === 'date' && (
                              <Form.Item name={i}>
                                <DatePicker.RangePicker
                                  style={{ width: '100%' }}
                                  ranges={option?.[i]?.ranges}
                                  getPopupContainer={(node: any) =>
                                    node.parentNode?.parentNode?.parentNode?.parentNode?.parentNode
                                      ?.parentNode?.parentNode?.parentNode || document.body
                                  }
                                  placeholder={
                                    (option?.[i]?.placeholder as [string, string]) || [
                                      option?.[i]?.label,
                                      option?.[i]?.label,
                                    ]
                                  }
                                />
                              </Form.Item>
                            )}
                            {option?.[i]?.type === 'dateNoTime' && (
                              <Form.Item name={i}>
                                <DatePicker.RangePicker
                                  style={{ width: '100%' }}
                                  getPopupContainer={() => document.body}
                                  placeholder={
                                    (option?.[i]?.placeholder as [string, string]) || [
                                      option?.[i]?.label,
                                      option?.[i]?.label,
                                    ]
                                  }
                                />
                              </Form.Item>
                            )}
                            {option?.[i]?.type === 'treeSelect' && (
                              <Form.Item name={i}>
                                <TreeSelect
                                  placeholder={option?.[i]?.label}
                                  allowClear={
                                    typeof option?.[i]?.allowClear === 'boolean'
                                      ? option?.[i]?.allowClear
                                      : true
                                  }
                                  showSearch
                                  showArrow
                                  onBlur={() => {
                                    setIsFocus({ blurType: i, focusType: '' })
                                  }}
                                  maxTagTextLength={5}
                                  maxTagCount={option?.[i]?.maxLength ? option?.[i]?.maxLength : 1}
                                  getPopupContainer={(node: any) =>
                                    node.parentNode?.parentNode?.parentNode?.parentNode?.parentNode
                                      ?.parentNode?.parentNode?.parentNode || document.body
                                  }
                                  treeCheckable
                                  // treeNodeLabelProp={'name'}
                                  treeData={option?.[i]?.data}
                                />
                              </Form.Item>
                            )}
                            {option?.[i]?.type !== 'input' &&
                              option?.[i]?.type !== 'time' &&
                              option?.[i]?.type !== 'date' &&
                              option?.[i]?.type !== 'dateCurrentTime' &&
                              option?.[i]?.type !== 'dateNoTime' &&
                              option?.[i]?.type !== 'treeSelect' && (
                                <Form.Item name={i}>
                                  <Select
                                    virtual={false}
                                    data-placeholder={option?.[i]?.label}
                                    allowClear={
                                      typeof option?.[i]?.allowClear === 'boolean'
                                        ? option?.[i]?.allowClear
                                        : true
                                    }
                                    showSearch
                                    optionFilterProp={'label'}
                                    showArrow
                                    onBlur={() => {
                                      setIsFocus({ blurType: i, focusType: '' })
                                    }}
                                    mode={option?.[i]?.type as 'multiple' | 'tags'}
                                    maxTagTextLength={4}
                                    maxTagCount={
                                      option?.[i]?.maxLength ? option?.[i]?.maxLength : 2
                                    }
                                    getPopupContainer={(node: any) =>
                                      node.parentNode?.parentNode?.parentNode?.parentNode
                                        ?.parentNode?.parentNode?.parentNode?.parentNode ||
                                      document.body
                                    }
                                    placeholder={option?.[i]?.placeholder as string}
                                  >
                                    {option?.[i]?.data?.map((optionItem, index3) =>
                                      optionItem.count ? (
                                        <Select.Option
                                          key={optionItem.id || index3}
                                          value={optionItem.id}
                                          name={optionItem.name}
                                          label={optionItem.name}
                                        >
                                          {optionItem.name}
                                          <span style={{ color: '#558492' }}>
                                            {optionItem.count || 0}
                                          </span>
                                        </Select.Option>
                                      ) : (
                                        <Select.Option
                                          key={optionItem.id || index3}
                                          value={optionItem.id}
                                          name={optionItem.name}
                                          label={optionItem.name}
                                        >
                                          {optionItem.name}
                                        </Select.Option>
                                      ),
                                    )}
                                  </Select>
                                </Form.Item>
                              )}
                          </div>
                        )
                      }
                    })}
                  </div>
                )
              })}
            </Form>
            <div className="filter-dashed">
              {SearchData?.length > 1 ? (
                <div
                  className="filter-flex"
                  onClick={() => {
                    setVisible(!visible)
                    r(!visible ? 52 * SearchData?.length : 52)
                  }}
                >
                  <div>{visible ? t('收起') : t('展开')}</div>
                  <IconFont className="icon" type="icon-gengduo2" />
                </div>
              ) : (
                <div className="filter-flex" onClick={reset}>
                  {t('重置')}
                </div>
              )}
            </div>
          </div>
        )}
      </FilterContent>
    )
  },
)
const FilterContent = styled.div`
  .ant-select-dropdown {
    z-index: 99;
  }
  .filter-search {
    display: flex;
    padding: 0 20px;
    border-bottom: 1px dashed #d5d9dd;
    margin-bottom: 12px;
    .filter-form {
      width: ${props =>
        props.isTime
          ? props.row === 3
            ? 'calc(100% - 340px)'
            : 'calc(100% - 60px)'
          : props.formLength < props.row
          ? `calc(${`100% / ${props.row}`}  * ${props.formLength}  - 60px)`
          : 'calc(100% - 60px)'};
      height: ${props =>
        props.isShow
          ? props?.visible
            ? props.isScript
              ? `${52 * (props.length - 1)}px`
              : `${52 * props.length}px`
            : '58px'
          : 'auto'};
      transition: all 0.2s;
      overflow: hidden;
      .filter-flex {
        width: 100%;
        display: flex;
        gap: 24px;
        .form-item {
          padding-top: 6px;
          width: ${props =>
            !props.isShow
              ? `calc(${`100% / ${props.formLength}`}  - 18px)`
              : `calc(${`100% / ${props.row}`}  - 18px)`};
        }
        .ant-form-item {
          margin-bottom: 14px;
        }
      }
    }

    .filter-dashed {
      align-items: center;
      display: flex;
      height: 32px;
      gap: 20px;
      margin-top: 6px;
      width: 60px;
      justify-content: flex-end;
      /* margin-left: 20px; */
      .filter-flex {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #4238c9;
        /* width: 64px; */
        cursor: pointer;
        .icon {
          transition: all 0.2s;
          transform: ${props => (props.visible ? 'rotateZ(-90deg)' : 'rotateZ(90deg)')};
          margin-left: 8px;
          font-size: 12px;
        }
      }
    }
  }

  .tree-item,
  .input-item,
  .radio-item,
  .multiple-item {
    position: relative;
    &::after {
      content: attr(data-placeholder);
      display: block;
      padding: 0 4px;
      position: absolute;
      line-height: 6px;
      left: 8px;
      top: 18px;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1),
        max-width 0.324s cubic-bezier(0.4, 0, 0.2, 1);
      color: #999;
      z-index: 1;
      font-size: 14px;
      pointer-events: none;
    }
  }
  .input-item {
    &::after {
      left: 30px;
    }
  }
  .tree-item:focus-within,
  .radio-item:focus-within,
  .multiple-item:focus-within,
  .focus-item {
    &::after {
      background-color: #fff;
      transform: translate(-6px, -15px) scale(0.8);
    }
  }
  .input-item:focus-within,
  .input-item.focus-item {
    &::after {
      background-color: #fff;
      transform: translate(-16px, -15px) scale(0.8);
    }
  }
  input::placeholder {
    color: #999;
  }
  .ant-select-selection-placeholder {
    color: #999;
  }
`
